import { BotTemplateData } from "@shared/types";
import { toFixed } from "@shared/utils/numbers";
import {
  getBotTagsData,
  getDirectionAndMarginTag,
} from "@shared/features/bots/utils";
import { formatSignedPercent } from "features/bots/NewLook/newLookBotUtils";

/** A ratio as a signed percent: 0.183 -> "+18.3%". */
export const toPercentText = (ratio: number) =>
  formatSignedPercent(toFixed(ratio * 100, 2));

/** A value that already is a percent: 18.3 -> "+18.3%". */
export const toSignedPercent = (percent: number) =>
  formatSignedPercent(toFixed(percent, 2));

/**
 * The bot's direction and margin as separate chips, with the classic tag's
 * wording ("Long - Isolated 3x" -> ["Long", "Isolated 3x"]).
 */
export const getPublicBotChips = (botData?: BotTemplateData) =>
  getDirectionAndMarginTag(botData).split(" - ");

/** The bot's tags as one quiet line: "Popular · Trending". */
export const getPublicBotTagsText = (botData: BotTemplateData) =>
  getBotTagsData(botData)
    .map((tagData) => tagData.tag)
    .join(" · ");
